import { useAdvisorDeleteMutation } from "web_myplann/Api/Advisor/useAdvisorDeleteMutation";
import { useAdvisorDetailQuery } from "web_myplann/Api/Advisor/useAdvisorDetailQuery";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const useDeleteAdvisor = (
	advisor: AgentAssignedListItemResponseDTO | undefined,
	onDeleted: () => void,
) => {
	const { data: detail } = useAdvisorDetailQuery(advisor?.uid);
	const { mutate: deleteAdvisor, isPending } = useAdvisorDeleteMutation();

	const confirmDelete = (
		confirmedAdvisor: AgentAssignedListItemResponseDTO,
		onSuccess: () => void,
	) => {
		deleteAdvisor(confirmedAdvisor, {
			onSuccess: () => {
				onSuccess();
				onDeleted();
			},
		});
	};

	return {
		canDelete: detail?.canDisconnect === true,
		hasSharedData: detail?.hasSharedData === true,
		isPending,
		confirmDelete,
	};
};
